import type { MonospaceServiceAccount, MonospaceSystemWorkspaceMember } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { Workspace } from './workspace';

export const ServiceAccount = RStoreSchema.withItemType<MonospaceServiceAccount>().defineCollection({
	name: 'MonospaceServiceAccount',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: [
			'id',
			'fullName',
		],
		endpoint: 'system/service-accounts',
	},
});

// Junction table between User/ServiceAccount and Workspace
export const SystemWorkspaceMember = RStoreSchema.withItemType<MonospaceSystemWorkspaceMember>().defineCollection({
	name: 'MonospaceWorkspaceMember',
	scopeId: 'monospace-default',
	getKey: (item) => `${item.userId}__${item.workspaceId}`,
	meta: {
		defaultFields: ['userId', 'workspaceId'],
	},
});

export const ServiceAccountRelations = RStoreSchema.defineRelations(ServiceAccount, ({ collection }) => ({
	workspaces: {
		to: collection(SystemWorkspaceMember, {
			on: {
				'MonospaceWorkspaceMember.userId': 'MonospaceServiceAccount.id',
			},
		}),
		many: true,
	},
}));

export const SystemWorkspaceMemberRelations = RStoreSchema.defineRelations(SystemWorkspaceMember, ({ collection }) => ({
	workspace: {
		to: collection(Workspace, {
			on: {
				'MonospaceWorkspace.id': 'MonospaceWorkspaceMember.workspaceId',
			},
		}),
	},
}));
